import 'core-js/modules/es.array.concat';
import 'core-js/modules/es.array.join';
import 'core-js/modules/es.array.map';
import 'core-js/modules/es.array.slice';
import 'core-js/modules/es.array.splice';
import 'core-js/modules/es.object.assign';
import 'core-js/modules/es.object.values';
import 'core-js/modules/es.regexp.exec';
import 'core-js/modules/es.string.replace';
import 'core-js/modules/es.string.split';
import { isWorldReadyInstance } from '@paypalcorp/worldready-core';
import { assert, assertType, assertRange } from 'yaassertion';
import { NumberFormat } from '@paypalcorp/worldready-number';
import '@paypalcorp/globalize/dist/globalize/number';
import '@paypalcorp/globalize/dist/globalize/currency';
import '@paypalcorp/globalize/dist/globalize/plural';

function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}

var _excluded = ["style", "currency"];
var getMissingMetadataError = function getMissingMetadataError(path) {
  var message = "Missing WorldReady metadata, please refer to https://github.paypal.com/pages/Globalization-R/worldready-js/docs/about-load-worldready-data.html";
  if (path) {
    message += "\nPath: " + path;
  }
  return new Error(message);
};
function globalizeToWorldReadyError(error) {
  if (error.code === "E_MISSING_CLDR") {
    return getMissingMetadataError(error.stack);
  }
  return new Error(["Oops, internal error", error.message, error.stack].join("\n"));
}
function validateCldr(path, value, options) {
  if (options === void 0) {
    options = {
      skip: []
    };
  }
  var skipBoolean = options.skip.some(function (regex) {
    return regex.test(path);
  });
  if (skipBoolean) {
    return;
  }
  if (value === undefined) {
    throw getMissingMetadataError(path);
  }
}

/**
 * Note:
 * - Below, we "borrow code" from globalize since it doesn't export the resolved properties.
 *   https://github.com/globalizejs/globalize/blob/8f4f2bffed00231aa2f7f4f46c3a4687ace46ab6/src/number.js
 *   https://github.com/globalizejs/globalize/blob/8f4f2bffed00231aa2f7f4f46c3a4687ace46ab6/src/number/pattern-properties.js
 *   https://github.com/globalizejs/globalize/blob/8f4f2bffed00231aa2f7f4f46c3a4687ace46ab6/src/number/format-properties.js
 * - NOT using numberFormatter.runtimeArgs because it's NOT available when code is minified.
 *
 * TODO: Expose resolvedOptions() in globalize and reuse it here.
 */

function numberNumberingSystem(cldr) {
  var nu = cldr.attributes["u-nu"];
  if (nu) {
    if (nu === "traditio") {
      nu = "traditional";
    }
    if (["native", "traditional", "finance"].indexOf(nu) !== -1) {
      // Unicode locale extension `u-nu` is set using either (native, traditional or
      // finance). So, lookup the respective locale's numberingSystem and return it.
      return cldr.main(["numbers/otherNumberingSystems", nu]);
    }

    // Unicode locale extension `u-nu` is set with an explicit numberingSystem. Return it.
    return nu;
  }

  // Return the default numberingSystem.
  return cldr.main("numbers/defaultNumberingSystem");
}
function numberPattern(style, cldr) {
  if (style !== "decimal" && style !== "percent") {
    throw new Error("Invalid style");
  }
  return cldr.main(["numbers", style + "Formats-numberSystem-" + numberNumberingSystem(cldr), "standard"]);
}

/**
 * Note:
 * - Below, we "borrow code" from globalize since it doesn't export the resolved properties.
 *   https://github.com/globalizejs/globalize/blob/8f4f2bffed00231aa2f7f4f46c3a4687ace46ab6/src/currency.js
 *   https://github.com/globalizejs/globalize/blob/8f4f2bffed00231aa2f7f4f46c3a4687ace46ab6/src/number/pattern-properties.js
 *   https://github.com/globalizejs/globalize/blob/8f4f2bffed00231aa2f7f4f46c3a4687ace46ab6/src/number/format-properties.js
 * - NOT using numberFormatter.runtimeArgs because it's NOT available when code is minified.
 *
 * TODO: Expose resolvedOptions() in globalize and reuse it here.
 */

// eslint-disable-next-line
var regexpNotS = /[\0-#%-\*,-;\?-\]_a-\{\}\x7F-\xA1\xA7\xAA\xAB\xAD\xB2\xB3\xB5-\xB7\xB9-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376-\u0383\u0386-\u03F5\u03F7-\u0481\u0483-\u058C\u0590-\u0605\u0609\u060A\u060C\u060D\u0610-\u06DD\u06DF-\u06E8\u06EA-\u06FC\u06FF-\u07F5\u07F7-\u09F1\u09F4-\u09F9\u09FC-\u0AF0\u0AF2-\u0B6F\u0B71-\u0BF2\u0BFB-\u0C7E\u0C80-\u0D78\u0D7A-\u0E3E\u0E40-\u0F00\u0F04-\u0F12\u0F14\u0F18\u0F19\u0F20-\u0F33\u0F35\u0F37\u0F39-\u0FBD\u0FC6\u0FCD\u0FD0-\u0FD4\u0FD9-\u109D\u10A0-\u138F\u139A-\u17DA\u17DC-\u193F\u1941-\u19DD\u1A00-\u1B60\u1B6B-\u1B73\u1B7D-\u1FBC\u1FBE\u1FC2-\u1FCC\u1FD0-\u1FDC\u1FE0-\u1FEC\u1FF0-\u1FFC\u1FFF-\u2043\u2045-\u2051\u2053-\u2079\u207D-\u2089\u208D-\u209F\u20BE-\u20FF\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2150-\u218F\u2308-\u230B\u2329\u232A\u23FB-\u23FF\u2427-\u243F\u244B-\u249B\u24EA-\u24FF\u2768-\u2793\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2B74\u2B75\u2B96\u2B97\u2BBA-\u2BBC\u2BC9\u2BD2-\u2CE4\u2CEB-\u2E7F\u2E9A\u2EF4-\u2EFF\u2FD6-\u2FEF\u2FFC-\u3003\u3005-\u3011\u3014-\u301F\u3021-\u3035\u3038-\u303D\u3040-\u309A\u309D-\u318F\u3192-\u3195\u31A0-\u31BF\u31E4-\u31FF\u321F-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\u32FF\u3400-\u4DBF\u4E00-\uA48F\uA4C7-\uA6FF\uA717-\uA71F\uA722-\uA788\uA78B-\uA827\uA82C-\uA835\uA83A-\uAA76\uAA7A-\uAB5A\uAB5C-\uD7FF\uDC00-\uFB28\uFB2A-\uFBB1\uFBC2-\uFDFB\uFDFE-\uFE61\uFE63\uFE67\uFE68\uFE6A-\uFF03\uFF05-\uFF0A\uFF0C-\uFF1B\uFF1F-\uFF3D\uFF3F\uFF41-\uFF5B\uFF5D\uFF5F-\uFFDF\uFFE7\uFFEF-\uFFFB\uFFFE\uFFFF]|\uD800[\uDC00-\uDD36\uDD40-\uDD78\uDD8A\uDD8B\uDD8D-\uDD8F\uDD9C-\uDD9F\uDDA1-\uDDCF\uDDFD-\uDFFF]|[\uD801\uD803-\uD819\uD81B-\uD82E\uD830-\uD833\uD836-\uD83A\uD83F-\uDBFF][\uDC00-\uDFFF]|\uD802[\uDC00-\uDC76\uDC79-\uDEC7\uDEC9-\uDFFF]|\uD81A[\uDC00-\uDF3B\uDF40-\uDF44\uDF46-\uDFFF]|\uD82F[\uDC00-\uDC9B\uDC9D-\uDFFF]|\uD834[\uDCF6-\uDCFF\uDD27\uDD28\uDD65-\uDD69\uDD6D-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDDDE-\uDDFF\uDE42-\uDE44\uDE46-\uDEFF\uDF57-\uDFFF]|\uD835[\uDC00-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFFF]|\uD83B[\uDC00-\uDEEF\uDEF2-\uDFFF]|\uD83C[\uDC2C-\uDC2F\uDC94-\uDC9F\uDCAF\uDCB0\uDCC0\uDCD0\uDCF6-\uDD0F\uDD2F\uDD6C-\uDD6F\uDD9B-\uDDE5\uDE03-\uDE0F\uDE3B-\uDE3F\uDE49-\uDE4F\uDE52-\uDEFF\uDF2D-\uDF2F\uDF7E\uDF7F\uDFCF-\uDFD3\uDFF8-\uDFFF]|\uD83D[\uDCFF\uDD4B-\uDD4F\uDD7A\uDDA4\uDE43\uDE44\uDED0-\uDEDF\uDEED-\uDEEF\uDEF4-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDFFF]|[\uD800-\uDBFF]/;
// eslint-disable-next-line
var regexpNotSNotZ = /[\0-\x1F!-#%-\*,-;\?-\]_a-\{\}\x7F-\x9F\xA1\xA7\xAA\xAB\xAD\xB2\xB3\xB5-\xB7\xB9-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376-\u0383\u0386-\u03F5\u03F7-\u0481\u0483-\u058C\u0590-\u0605\u0609\u060A\u060C\u060D\u0610-\u06DD\u06DF-\u06E8\u06EA-\u06FC\u06FF-\u07F5\u07F7-\u07FD\u0800-\u09F1\u09F4-\u09F9\u09FC-\u0AF0\u0AF2-\u0B6F\u0B71-\u0BF2\u0BFB-\u0C7E\u0C80-\u0D4E\u0D50-\u0D78\u0D7A-\u0E3E\u0E40-\u0F00\u0F04-\u0F12\u0F14\u0F18\u0F19\u0F20-\u0F33\u0F35\u0F37\u0F39-\u0FBD\u0FC6\u0FCD\u0FD0-\u0FD4\u0FD9-\u109D\u10A0-\u138F\u139A-\u166C\u166E-\u167F\u1681-\u17DA\u17DC-\u193F\u1941-\u19DD\u1A00-\u1B60\u1B6B-\u1B73\u1B7D-\u1FBC\u1FBE\u1FC2-\u1FCC\u1FD0-\u1FDC\u1FE0-\u1FEC\u1FF0-\u1FFC\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u2043\u2045-\u2051\u2053-\u205E\u2060-\u2079\u207D-\u2089\u208D-\u209F\u20C0-\u20FF\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2150-\u2189\u218C-\u218F\u2308-\u230B\u2329\u232A\u2427-\u243F\u244B-\u249B\u24EA-\u24FF\u2768-\u2793\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2B74\u2B75\u2B96\u2C00-\u2CE4\u2CEB-\u2E4F\u2E52-\u2E7F\u2E9A\u2EF4-\u2EFF\u2FD6-\u2FEF\u2FFC-\u2FFF\u3001-\u3003\u3005-\u3011\u3014-\u301F\u3021-\u3035\u3038-\u303D\u3040-\u309A\u309D-\u318F\u3192-\u3195\u31A0-\u31BF\u31E4-\u31FF\u321F-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\u3400-\u4DBF\u4E00-\uA48F\uA4C7-\uA6FF\uA717-\uA71F\uA722-\uA788\uA78B-\uA827\uA82C-\uA835\uA83A-\uAA76\uAA7A-\uAB5A\uAB5C-\uAB69\uAB6C-\uD7FF\uE000-\uFB28\uFB2A-\uFBB1\uFBC2-\uFDFB\uFDFE-\uFE61\uFE63\uFE67\uFE68\uFE6A-\uFF03\uFF05-\uFF0A\uFF0C-\uFF1B\uFF1F-\uFF3D\uFF3F\uFF41-\uFF5B\uFF5D\uFF5F-\uFFDF\uFFE7\uFFEF-\uFFFB\uFFFE\uFFFF]|\uD800[\uDC00-\uDD36\uDD40-\uDD78\uDD8A\uDD8B\uDD8F\uDD9D-\uDD9F\uDDA1-\uDDCF\uDDFD-\uDFFF]|[\uD801\uD803\uD804\uD806\uD808-\uD819\uD81B-\uD82E\uD830-\uD833\uD837\uD839\uD83A\uD83F-\uDBFF][\uDC00-\uDFFF]|\uD802[\uDC00-\uDC76\uDC79-\uDEC7\uDEC9-\uDFFF]|\uD805[\uDC00-\uDF3E\uDF40-\uDFFF]|\uD807[\uDC00-\uDFD4\uDFF2-\uDFFF]|\uD81A[\uDC00-\uDF3B\uDF40-\uDF44\uDF46-\uDFFF]|\uD82F[\uDC00-\uDC9B\uDC9D-\uDFFF]|\uD834[\uDCF6-\uDCFF\uDD27\uDD28\uDD65-\uDD69\uDD6D-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDDE9-\uDDFF\uDE42-\uDE44\uDE46-\uDEFF\uDF57-\uDFFF]|\uD835[\uDC00-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFFF]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE87-\uDFFF]|\uD838[\uDC00-\uDD4E\uDD50-\uDEFE\uDF00-\uDFFF]|\uD83B[\uDC00-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDD2D\uDD2F-\uDEEF\uDEF2-\uDFFF]|\uD83C[\uDC2C-\uDC2F\uDC94-\uDC9F\uDCAF\uDCB0\uDCC0\uDCD0\uDCF6-\uDD0C\uDDAE-\uDDE5\uDE03-\uDE0F\uDE3C-\uDE3F\uDE49-\uDE4F\uDE52-\uDE5F\uDE66-\uDEFF]|\uD83D[\uDED8-\uDEDF\uDEED-\uDEEF\uDEFD-\uDEFF\uDF74-\uDF7F\uDFD9-\uDFDF\uDFEC-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE\uDCAF\uDCB2-\uDCFF\uDD79\uDDCC\uDE54-\uDE5F\uDE6E\uDE6F\uDE75-\uDE77\uDE7B-\uDE7F\uDE87-\uDE8F\uDEA9-\uDEAF\uDEB7-\uDEBF\uDEC3-\uDECF\uDED7-\uDEFF\uDF93\uDFCB-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
function stringPad(str, count, right) {
  var length;
  if (typeof str !== "string") {
    str = String(str);
  }
  for (length = str.length; length < count; length += 1) {
    str = right ? str + "0" : "0" + str;
  }
  return str;
}
function currencySupplementalOverride(currency, pattern, cldr) {
  var digits,
    fraction = "",
    fractionData = cldr.supplemental(["currencyData/fractions", currency]) || cldr.supplemental("currencyData/fractions/DEFAULT");
  digits = +fractionData._digits;
  if (digits) {
    fraction = "." + stringPad("0", digits).slice(0, -1) + fractionData._rounding;
  }
  return pattern.replace(/\.(#+|0*[0-9]|0+[0-9]?)/g, fraction);
}
function currencyNameProperties(currency, cldr) {
  var pattern = numberPattern("decimal", cldr);

  // The number of decimal places and the rounding for each currency is not locale-specific. Those
  // values overridden by Supplemental Currency Data.
  pattern = currencySupplementalOverride(currency, pattern, cldr);
  return {
    pattern: pattern
  };
}
function currencySymbolProperties(currency, cldr, options) {
  var currencySpacing,
    pattern,
    symbol,
    symbolEntries,
    regexp = {
      "[:digit:]": /\d/,
      "[:^S:]": regexpNotS,
      "[[:^S:]&[:^Z:]]": regexpNotSNotZ
    };
  if (options.style === "code") {
    symbol = currency;
  } else {
    symbolEntries = ["symbol"];

    // If options.symbolForm === "narrow" was passed, prepend it.
    if (options.symbolForm === "narrow") {
      symbolEntries.unshift("symbol-alt-narrow");
    }
    symbolEntries.some(function (symbolEntry) {
      return symbol = cldr.main(["numbers/currencies", currency, symbolEntry]);
    });
  }
  currencySpacing = ["beforeCurrency", "afterCurrency"].map(function (position) {
    return cldr.main(["numbers", "currencyFormats-numberSystem-" + numberNumberingSystem(cldr), "currencySpacing", position]);
  });
  pattern = cldr.main(["numbers", "currencyFormats-numberSystem-" + numberNumberingSystem(cldr), options.style === "accounting" ? "accounting" : "standard"]);
  pattern =
  // The number of decimal places and the rounding for each currency is not locale-specific.
  // Those values are overridden by Supplemental Currency Data.
  currencySupplementalOverride(currency, pattern, cldr)
  // Replace "¤" (\u00A4) with the appropriate symbol literal.
  .split(";").map(function (pattern) {
    return pattern.split("\xA4").map(function (part, i) {
      var currencyMatch = regexp[currencySpacing[i].currencyMatch],
        surroundingMatch = regexp[currencySpacing[i].surroundingMatch],
        insertBetween = "";

      // For currencyMatch and surroundingMatch definitions, read [1].
      // When i === 0, beforeCurrency is being handled. Otherwise, afterCurrency.
      // 1: http://www.unicode.org/reports/tr35/tr35-numbers.html#Currencies
      currencyMatch = currencyMatch.test(symbol.charAt(i ? symbol.length - 1 : 0));
      surroundingMatch = surroundingMatch.test(part.charAt(i ? 0 : part.length - 1).replace(/[#@,.]/g, "0"));
      if (currencyMatch && part && surroundingMatch) {
        insertBetween = currencySpacing[i].insertBetween;
      }
      return (i ? insertBetween : "") + part + (i ? "" : insertBetween);
    }).join("\xA4");
  }).join(";");
  return {
    pattern: pattern
  };
}
function resolvedOptions(globalize, currency, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options,
    style = _options.style;
  var _accounting$code$name = {
      accounting: currencySymbolProperties,
      code: currencySymbolProperties,
      name: currencyNameProperties,
      symbol: currencySymbolProperties,
      international: currencySymbolProperties
    }[style](currency, globalize.cldr, options),
    raw = _accounting$code$name.pattern;
  return NumberFormat._resolvedOptions(globalize, {
    raw: raw
  });
}
var ENVIRONMENT = {
  PRODUCTION: "production"
};
var CURRENCY_STYLES = {
  SYMBOL: "symbol",
  CODE: "code",
  INTERNATIONAL: "international"
};

/***
 * Code imported from Griffin v2 to deal with PayPal-cystom-international pattern.
 * @input it takes 2 strings valueA and valueB
 * @returns {number} the percentage of how similar are both
 */
function fuzzyMatch(svalueA, svalueB) {
  if (svalueA === svalueB) {
    return 100;
  } else {
    var valueA = svalueA.split(""),
      valueB = svalueB.split(""),
      equivalency = 0;
    for (var i = 0; i < valueA.length; i++) {
      if (valueB.indexOf(valueA[i]) !== -1) {
        var position = valueB.indexOf(valueA[i]);
        valueB.splice(position, 1);
        equivalency++;
      }
    }
    var weight = equivalency / valueA.length;
    return weight * 100;
  }
}
var CurrencyFormat = /*#__PURE__*/function () {
  function CurrencyFormat(worldReady, options) {
    // Error Check: WorldReady Object
    if (process.env.NODE_ENV !== ENVIRONMENT.PRODUCTION) {
      assert(isWorldReadyInstance(worldReady), "WorldReady object missing.");
      assertType(options, "options", ["undefined", "plain object"]);
    }
    var _ref = options || {},
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? CURRENCY_STYLES.SYMBOL : _ref$style,
      currency = _ref.currency,
      otherOptions = _objectWithoutPropertiesLoose(_ref, _excluded);
    if (process.env.NODE_ENV !== ENVIRONMENT.PRODUCTION) {
      assertType(currency, "options.currency", ["string"]);
      assertType(style, "options.style", ["string"]);
      assertRange(style, ["symbol", "code", "name", "international"], "options.style must be one of " + Object.values(CURRENCY_STYLES).join(", "));
    }
    currency = currency.toUpperCase();
    this.currencyMetadata = null;
    var cldr = worldReady.globalize.cldr;
    cldr.on("main", validateCldr);
    try {
      this.currencyMetadata = cldr.main("numbers/currencies/" + currency);
    } catch (error) {
      globalizeToWorldReadyError(error);
    }

    // Support PayPal custom international format by hacking Globalize and overwrite the symbol --- START
    // pattern with the PayPal-custom-international pattern.
    // This hack is possible because JavaScript is single threaded and there's no race condition.
    // The below synchronous code will finish execution before any other async queued event run.
    var aux;
    if (style === CURRENCY_STYLES.INTERNATIONAL) {
      var _cldr = worldReady.globalize.cldr;
      var data = _cldr.main("numbers/currencyFormats-numberSystem-latn");
      aux = [data, CURRENCY_STYLES.INTERNATIONAL, data.standard];

      // Use PayPal-international currency override (e.g., TRY) or default PayPal-international.
      var pattern = _cldr.main(["numbers/currencyFormats-numberSystem-latn/currency_override", currency, CURRENCY_STYLES.INTERNATIONAL]) || _cldr.main("numbers/currencyFormats-numberSystem-latn/international");

      // Avoid showing ISO code when it's too similar to symbol,
      // e.g., MXN and $MX.
      // PS: Also ignore spaces when checking similarity to avoid cases like: fr-BW: "1 234,50 $ US USD"
      if (/¤/.test(pattern)) {
        var symbolWithoutSpaces = (_cldr.main(["numbers/currencies", currency, "symbol-alt-narrow"]) || _cldr.main(["numbers/currencies", currency, "symbol"]) || "").replace(/\s/g, "");
        if (fuzzyMatch(currency, symbolWithoutSpaces) >= 66) {
          pattern = pattern.replace(/\s*C/g, "");
        }
      }
      data.standard = pattern;
      style = CURRENCY_STYLES.SYMBOL;

      // use symbolForm narrow in order to show es-MX: $1,234.50 USD instead of USD 1,234.50 USD
      //symbolForm = "narrow";
      otherOptions.symbolForm = "narrow";
    }
    try {
      this.currencyToPartsFormatter = worldReady.globalize.currencyToPartsFormatter(currency, Object.assign({
        style: style
      }, otherOptions));
    } catch (error) {
      throw globalizeToWorldReadyError(error);
    }

    // Support PayPal custom international format --- END
    if (aux) {
      var _aux = aux,
        _data = _aux[0];
      var _aux2 = aux;
      style = _aux2[1];
      _data.standard = _aux2[2];
    }
    this.currency = currency;
    this.style = style;
    var resolvedOptionsCache;
    this._resolvedOptions = function () {
      if (!resolvedOptionsCache) {
        resolvedOptionsCache = resolvedOptions(worldReady.globalize, currency, Object.assign({
          style: style
        }, otherOptions));
      }
      return resolvedOptionsCache;
    };
  }
  var _proto = CurrencyFormat.prototype;
  _proto.format = function format(value) {
    return this.formatToParts(value).map(function (part) {
      return part.value;
    }).join("");
  };
  _proto.formatToParts = function formatToParts(value) {
    var parts = this.currencyToPartsFormatter(value);

    // Support PayPal custom formats that may include the currency ISO code regardless of the chosen
    // style. The following code hacks globalize currency formatter internals by replacing
    // "C"-PayPal-custom-pattern from the PayPal-overriden-metadata with the currency ISO code.
    for (var i = 0; i < parts.length; i++) {
      var part = parts[i];
      if (part.type === "literal" && part.value.indexOf("C") !== -1) {
        var _part$value$split = part.value.split(/C/),
          preLiteral = _part$value$split[0],
          postLiteral = _part$value$split[1];
        parts.splice.apply(parts, [i, 1].concat([].concat(preLiteral ? [{
          type: "literal",
          value: preLiteral
        }] : [], [{
          type: this.style === CURRENCY_STYLES.SYMBOL ? "currencySymbol" : "currencyCode",
          value: this.currency
        }], postLiteral ? [{
          type: "literal",
          value: postLiteral
        }] : [])));
      }
      // Rename type from "currency" to "currencySymbol"
      if (part.type === "currency") {
        if (this.currencyMetadata["symbol-alt-narrow"] && part.value === this.currencyMetadata["symbol-alt-narrow"] || this.currencyMetadata.symbol && part.value === this.currencyMetadata.symbol) {
          part.type = "currencySymbol";
          parts.splice(i, 1, {
            type: "currencySymbol",
            value: part.value
          });
        }
      }

      // We want the type to be "currencyCode" for currencies ("USD", "EUR", etc.)
      if (part.type === "currency" && part.value === this.currency) {
        parts.splice(i, 1, {
          type: "currencyCode",
          value: this.currency
        });
      }
    }
    return parts;
  };
  _proto.resolvedOptions = function resolvedOptions() {
    return this._resolvedOptions();
  };
  return CurrencyFormat;
}();

export { CurrencyFormat };
